// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1R4Zx","text":"SelectPayment_text__1j2Pl","title":"SelectPayment_title__2i5_1","btn":"SelectPayment_btn__1IylB"};